import { Box } from '@mui/material';
import { ResponsiveLine } from '@nivo/line';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function BuySellSentiment({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const lineData = [{
        id: 'Buy/Sell Ratio',
        data: data.map(m => ({ x: m.month, y: m.ratio })),
    }];

    return (
        <ChartSection id="sentiment" title="Is Congress bullish or bearish right now?" subtitle="Monthly buy/sell ratio — above 1.0 = more buying than selling">
            <Box sx={{ height: 350 }}>
                <ResponsiveLine
                    data={lineData}
                    margin={{ top: 20, right: 20, bottom: 60, left: 50 }}
                    xScale={{ type: 'point' }}
                    yScale={{ type: 'linear', min: 0, max: 'auto' }}
                    curve="monotoneX" enablePoints={false} enableGridX={false}
                    colors={[colors.primary]} lineWidth={2}
                    enableArea areaOpacity={0.06}
                    axisBottom={{ tickRotation: 45, tickValues: data.filter((_, i) => i % 12 === 0).map(m => m.month) }}
                    axisLeft={{ legend: 'Buy/Sell Ratio', legendPosition: 'middle', legendOffset: -40 }}
                    markers={[{ axis: 'y', value: 1, lineStyle: { stroke: colors.muted, strokeDasharray: '4 4' }, legend: 'Neutral (1:1)', textStyle: { fill: colors.muted, fontSize: 10 } }]}
                    enableSlices="x"
                    sliceTooltip={({ slice }) => {
                        const p = slice.points[0];
                        const y = Number(p.data.y);
                        return (
                            <ChartTooltip
                                title={String(p.data.x)}
                                rows={[
                                    {
                                        label: 'Buy/Sell',
                                        value: y.toFixed(2) + 'x',
                                        color: p.seriesColor,
                                        valueColor: y >= 1 ? 'success.main' : 'error.main',
                                    },
                                    {
                                        label: 'Sentiment',
                                        value: y >= 1 ? 'Bullish' : 'Bearish',
                                    },
                                ]}
                            />
                        );
                    }}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
